import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-verifyemail',
  templateUrl: './verifyemail.component.html',
  styleUrls: ['./verifyemail.component.scss']
})
export class VerifyemailComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
